import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { Grid } from '@mui/material';
import CommonEditableTable from 'components/commonEditableTable/CommonEditableTable';

export default function RateCardTab(props) {
  const handleChange = (event, newValue,) => {
    props?.handleChange(newValue)
  };
  
  return (
    <Grid container>

      <Grid item className="tableContainer" xs={12}>
        <Box className="contentBoxStyle">
          <TabContext value={props?.tripType?.id?.toString()}>
            <Grid
              container
              className="tabBoxStyle pl40"
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <Grid item >
                <TabList
                className='minHeight32'
                  onChange={handleChange}
                  aria-label="lab API tabs example"
                >
                  <Tab
                    label="Base Rate"
                    value="2"
                    className="tabStyle"
                  />
                  <Tab label="Extra KM / Hr Rate" value="3" className="tabStyle" />
                </TabList>
              </Grid>
            </Grid>
            <TabPanel value="2" sx={{ width: '100%' }} className='vendotTable'>
              <CommonEditableTable
                rateCardData={props?.rateCardData} 
                onSubmitData={props?.onSubmitData} 
                tripType={props?.tripType} 
              />
            </TabPanel>
            <TabPanel value="3" className='vendotTable'>
              <CommonEditableTable 
                rateCardData={props?.rateCardData} 
                onSubmitData={props?.onSubmitData} 
                tripType={props?.tripType} 
              />
            </TabPanel>
          </TabContext>
        </Box>
      </Grid>
    </Grid>
  );
}
